<template>
  <footer class="footer pt-4">
  <b-container fluid class="p-1">
    <div class="text-center pt-4 bg-dark">
      <img v-bind:src="$i18n.locale === 'fr' ? 'Images/3ValeursBlancVert250X250.png' : 'Images/3ValuesBlancVert250X250.png'" alt="3 values Cogir">
      <div class="row">
        <div class="col-sm-12 text-center pt-4">
          <a class="text-white btn btn-link text-attr-info" href="http://www.cogir.net/" target="blank">Cogir.net</a>
          <a class="text-white btn btn-link text-attr-info" href="https://www.residencescogir.com/" target="blank">ResidencesCogir.com</a>
        </div>
        <div class="col-sm-12 text-center pt-4 pb-4">
          <a href="https://www.facebook.com/CogirImmobilierRealEstate/" target="blank" class="text-white mr-4"><font-awesome-icon :icon="facebook" size="lg"/></a>
          <a href="https://twitter.com/CogirImmobilier" target="blank" class="text-white mr-4"><font-awesome-icon :icon="twitter" size="lg"/></a>
          <a href="https://www.linkedin.com/company/soci-t-de-gestion-cogir" target="blank" class="text-white mr-4"><font-awesome-icon :icon="linkedin" size="lg"/></a>
        </div>
      </div>
    </div>
  </b-container>
</footer>
</template>

<script>

import { faFacebookF, faTwitter, faLinkedin} from '@fortawesome/free-brands-svg-icons';

export default {
  data: () => ({
  position: ""
  }),
  computed: {
    facebook () {
      return faFacebookF;
    },
    twitter () {
      return faTwitter;
    },
    linkedin () {
      return faLinkedin;
    }
  },
  methods:{
  },
  components: {}
}
</script>
